import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";

export default function Add_data_modal({
  select_data,
  open_update_data_modal,
  onUpdateLeaseHistory,
}) {
  const [ren, setRen] = useState(false);
  const [update_modal_data, setUpdate_modal_data] = useState(select_data);
  const [add_data_modal_Show, set_update_data_modal_Show] = useState(false);

  useEffect(() => {
    if (select_data) {
      setUpdate_modal_data(select_data);
    }
  }, [select_data]);

  useEffect(() => {
    set_update_data_modal_Show(open_update_data_modal.modal_open);
  }, [open_update_data_modal]);

  const handleClose = () => {
    set_update_data_modal_Show(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleUpdate = async () => {
    const token = localStorage.getItem("token");

    Swal.fire({
      icon: "warning",
      title: "Are you sure you want to take this action?",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const { _id, actualAmount, comments } = update_modal_data;
          if (!_id) {
            throw new Error("ID is not defined");
          }

          const requestBody = {
            updateData: {
              actualAmount: actualAmount || "0",
              comments: comments || "",
            },
          };

          const res = await axios.put(
            `${process.env.REACT_APP_BASE_URL}/api/v4/lease-history/update?leaseHistoryId=${_id}`,
            requestBody,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );

          if (res.data.success) {
            Swal.fire("Update success", "", "success");

            const updatedData = res.data.data;

            // Notify parent component
            if (onUpdateLeaseHistory) {
              onUpdateLeaseHistory(updatedData);
            }

            setUpdate_modal_data(updatedData);
            set_update_data_modal_Show(false);
            setRen((prev) => !prev);
          } else {
            Swal.fire("Update failed", "", "error");
          }
        } catch (error) {
          Swal.fire("Update failed", "", "error");

          if (error.response) {
            console.error("❌ Server error:", error.response.data);
          } else if (error.request) {
            console.error("❌ No response:", error.request);
          } else {
            console.error("❌ Request setup error:", error.message);
          }
        }
      } else {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  return (
    <Modal show={add_data_modal_Show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Update Invoice Data</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Actual Amount</Form.Label>
            <Form.Control
              type="number"
              name="actualAmount"
              value={update_modal_data.actualAmount || ""}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Comments</Form.Label>
            <Form.Control
              type="text"
              name="comments"
              value={update_modal_data.comments || ""}
              onChange={handleChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" className="btn btn-sm" onClick={handleUpdate}>
          Update Invoice
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
